function validate (value) {     
    try {
        var dia = parseInt(value.substring(0, 2));
        var mes = parseInt(value.substring(3, 5));  
        var ano = parseInt(value.substring(6, 10));        

        if(mes<0 || mes>12 ){
            return false;
        }

        let dia_maximo = (mes==4 || mes==6 || mes==9 || mes==11) ? 30: 31;
        
        if(mes===2){            
            let ano_bisesto = ((ano%4)==0);           
            dia_maximo = ano_bisesto ? 29 : 28;
        }

        if(dia<0 || dia>dia_maximo ){
            return false;
        }

        return true;
     }
     catch (e) {
        return false;
     }

  
  }
  export default validate